var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: _vm.dialogTitle,
        visible: _vm.dialogVisible,
        width: "800px",
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
        close: _vm.handleClose,
      },
    },
    [
      _c(
        "el-form",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.formLoading,
              expression: "formLoading",
            },
          ],
          ref: "formRef",
          attrs: {
            model: _vm.formData,
            rules: _vm.formRules,
            "label-width": "120px",
          },
        },
        [
          _c(
            "el-row",
            { attrs: { gutter: 20 } },
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "订单号", prop: "orderNo" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入开票订单号" },
                        model: {
                          value: _vm.formData.orderNo,
                          callback: function ($$v) {
                            _vm.$set(_vm.formData, "orderNo", $$v)
                          },
                          expression: "formData.orderNo",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "订单ID", prop: "orderId" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入订单ID" },
                        model: {
                          value: _vm.formData.orderId,
                          callback: function ($$v) {
                            _vm.$set(_vm.formData, "orderId", _vm._n($$v))
                          },
                          expression: "formData.orderId",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-row",
            { attrs: { gutter: 20 } },
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "开票金额", prop: "invoiceAmount" } },
                    [
                      _c("el-input-number", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          precision: 2,
                          min: 0,
                          "controls-position": "right",
                          placeholder: "请输入开票金额",
                        },
                        model: {
                          value: _vm.formData.invoiceAmount,
                          callback: function ($$v) {
                            _vm.$set(_vm.formData, "invoiceAmount", $$v)
                          },
                          expression: "formData.invoiceAmount",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "开票类型", prop: "invoiceType" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: { placeholder: "请选择开票类型" },
                          model: {
                            value: _vm.formData.invoiceType,
                            callback: function ($$v) {
                              _vm.$set(_vm.formData, "invoiceType", $$v)
                            },
                            expression: "formData.invoiceType",
                          },
                        },
                        [
                          _c("el-option", {
                            attrs: { label: "个人", value: 0 },
                          }),
                          _c("el-option", {
                            attrs: { label: "企业", value: 1 },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-row",
            { attrs: { gutter: 20 } },
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "发票类型", prop: "category" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: { placeholder: "请选择发票类型" },
                          model: {
                            value: _vm.formData.category,
                            callback: function ($$v) {
                              _vm.$set(_vm.formData, "category", $$v)
                            },
                            expression: "formData.category",
                          },
                        },
                        [
                          _c("el-option", {
                            attrs: { label: "增值税普通发票", value: 1 },
                          }),
                          _c("el-option", {
                            attrs: { label: "增值税专用发票", value: 2 },
                          }),
                          _c("el-option", {
                            attrs: { label: "电子发票", value: 3 },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "发票状态", prop: "status" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: { placeholder: "请选择发票状态" },
                          model: {
                            value: _vm.formData.status,
                            callback: function ($$v) {
                              _vm.$set(_vm.formData, "status", $$v)
                            },
                            expression: "formData.status",
                          },
                        },
                        [
                          _c("el-option", {
                            attrs: { label: "申请中", value: 0 },
                          }),
                          _c("el-option", {
                            attrs: { label: "已开票", value: 1 },
                          }),
                          _c("el-option", {
                            attrs: { label: "已拒绝", value: 2 },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "发票抬头", prop: "invoiceTitle" } },
            [
              _c("el-input", {
                attrs: { placeholder: "请输入发票抬头" },
                model: {
                  value: _vm.formData.invoiceTitle,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "invoiceTitle", $$v)
                  },
                  expression: "formData.invoiceTitle",
                },
              }),
            ],
            1
          ),
          _vm.formData.invoiceType === 1
            ? _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "税号", prop: "taxNo" } },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请输入税号" },
                            model: {
                              value: _vm.formData.taxNo,
                              callback: function ($$v) {
                                _vm.$set(_vm.formData, "taxNo", $$v)
                              },
                              expression: "formData.taxNo",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "公司名称", prop: "companyName" } },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请输入公司名称" },
                            model: {
                              value: _vm.formData.companyName,
                              callback: function ($$v) {
                                _vm.$set(_vm.formData, "companyName", $$v)
                              },
                              expression: "formData.companyName",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm.formData.invoiceType === 1
            ? _c(
                "el-form-item",
                { attrs: { label: "公司地址", prop: "companyAddress" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入公司地址" },
                    model: {
                      value: _vm.formData.companyAddress,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "companyAddress", $$v)
                      },
                      expression: "formData.companyAddress",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm.formData.invoiceType === 1
            ? _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "公司电话", prop: "companyPhone" } },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请输入公司电话" },
                            model: {
                              value: _vm.formData.companyPhone,
                              callback: function ($$v) {
                                _vm.$set(_vm.formData, "companyPhone", $$v)
                              },
                              expression: "formData.companyPhone",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "邮箱", prop: "email" } },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请输入邮箱" },
                            model: {
                              value: _vm.formData.email,
                              callback: function ($$v) {
                                _vm.$set(_vm.formData, "email", $$v)
                              },
                              expression: "formData.email",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm.formData.invoiceType === 1 && _vm.formData.category === 2
            ? _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "银行名称", prop: "bankName" } },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请输入银行名称" },
                            model: {
                              value: _vm.formData.bankName,
                              callback: function ($$v) {
                                _vm.$set(_vm.formData, "bankName", $$v)
                              },
                              expression: "formData.bankName",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "银行账户", prop: "bankAccount" } },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请输入银行账户" },
                            model: {
                              value: _vm.formData.bankAccount,
                              callback: function ($$v) {
                                _vm.$set(_vm.formData, "bankAccount", $$v)
                              },
                              expression: "formData.bankAccount",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _c(
            "el-row",
            { attrs: { gutter: 20 } },
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "申请时间", prop: "applyTime" } },
                    [
                      _c("el-date-picker", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          type: "datetime",
                          placeholder: "选择申请时间",
                          "value-format": "yyyy-MM-dd HH:mm:ss",
                        },
                        model: {
                          value: _vm.formData.applyTime,
                          callback: function ($$v) {
                            _vm.$set(_vm.formData, "applyTime", $$v)
                          },
                          expression: "formData.applyTime",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "开票编码", prop: "invoiceCode" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入开票编码/申请单号" },
                        model: {
                          value: _vm.formData.invoiceCode,
                          callback: function ($$v) {
                            _vm.$set(_vm.formData, "invoiceCode", $$v)
                          },
                          expression: "formData.invoiceCode",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "附件地址", prop: "attachmentUrl" } },
            [
              _c("el-input", {
                attrs: { placeholder: "请输入附件地址" },
                model: {
                  value: _vm.formData.attachmentUrl,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "attachmentUrl", $$v)
                  },
                  expression: "formData.attachmentUrl",
                },
              }),
              _c(
                "div",
                { staticClass: "mt10" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", size: "small" },
                      on: {
                        click: function ($event) {
                          _vm.showUploadDialog = true
                        },
                      },
                    },
                    [_vm._v("上传附件")]
                  ),
                ],
                1
              ),
              _c(
                "el-dialog",
                {
                  attrs: {
                    title: "上传附件",
                    visible: _vm.showUploadDialog,
                    width: "500px",
                    "append-to-body": "",
                  },
                  on: {
                    "update:visible": function ($event) {
                      _vm.showUploadDialog = $event
                    },
                  },
                },
                [
                  _c("div", { staticClass: "upload-tip" }, [
                    _vm._v(
                      "请上传开票凭证，支持 PDF、DOC、DOCX、XLS、XLSX、JPG、PNG 格式，文件大小不超过 10MB"
                    ),
                  ]),
                  _c(
                    "div",
                    {
                      staticClass: "upLoadPicBox",
                      on: { click: _vm.modalPicTap },
                    },
                    [
                      _vm.uploadedFileUrl
                        ? _c("div", { staticClass: "pictrue" }, [
                            _c("img", { attrs: { src: _vm.uploadedFileUrl } }),
                          ])
                        : _c("div", { staticClass: "upLoad" }, [
                            _c("i", {
                              staticClass: "el-icon-camera cameraIconfont",
                            }),
                          ]),
                    ]
                  ),
                  _c(
                    "span",
                    { attrs: { slot: "footer" }, slot: "footer" },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: {
                            type: "primary",
                            disabled: !_vm.uploadedFileUrl,
                          },
                          on: { click: _vm.confirmUploadFile },
                        },
                        [_vm._v("确认上传")]
                      ),
                      _c(
                        "el-button",
                        {
                          on: {
                            click: function ($event) {
                              _vm.showUploadDialog = false
                            },
                          },
                        },
                        [_vm._v("取消")]
                      ),
                    ],
                    1
                  ),
                ]
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "备注", prop: "remark" } },
            [
              _c("el-input", {
                attrs: { type: "textarea", placeholder: "请输入备注", rows: 3 },
                model: {
                  value: _vm.formData.remark,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "remark", $$v)
                  },
                  expression: "formData.remark",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "span",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "el-button",
            {
              on: {
                click: function ($event) {
                  _vm.dialogVisible = false
                },
              },
            },
            [_vm._v("取 消")]
          ),
          _c(
            "el-button",
            {
              attrs: { type: "primary", loading: _vm.submitLoading },
              on: { click: _vm.submitForm },
            },
            [_vm._v("确 定")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }